import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import FieldCombo from '../combos/FieldCombo'
import SchoolClassCombo from '../combos/SchoolClassCombo';
import StudentSelector from '../school/StudentSelector';
import { Col, Form, Row } from 'react-bootstrap';
import ShowVideo from '../shared/ShowVideo';


export default function SetClassStudent(props) {
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [editFormVisible, setEditFormVisible] = useState(false);
    const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);

    
    const [currentItem, setCurrentItem] = useState([]);
    const [items, setItems] = useState([]);
    const [filterItems, setFilterItems] = useState([]);
    const LoadingRows = Array.from({length:5});

    const [schoolClassId, setSchoolClassId] = useState("");
    const [schoolClass, setSchoolClass] = useState({});
    const [studentSelectorOpen, setStudentSelectorOpen] = useState(false);
    const [studentListVisible, setStudentListVisible] = useState(false);


    useEffect(() => {

    }, []);

    const onDeleteConfirm_Accept = function(){
      deleteItems();
    }

    const onDeleteConfirm_Reject = function(){
        if(deleting) return;
        setConfirmDeleteVisible(false);
    }

    const deleteItems = function(){
      console.log("delete-->", currentItem);
      var userIds = [];
      for(var i = 0 ; i<currentItem.length; i++){
        userIds.push(currentItem[i].id);
      }
      console.log("ddd-->", userIds);
      setDeleting(true);
      var id = currentItem.id;
      var params = {login:util.getTrustedUser(), userIds:userIds, schoolClassId:schoolClass.id};
      var url = config.Server+`/school/school-class/students/list/delete`;
        axios
            .post(url, params )
            .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  var tmp = [...items];
                  for(var i=0;i<tmp.length;i++){
                    if(tmp[i].id === id){
                      tmp.splice(i, 1);
                      break;
                    }
                  }
                  setCurrentItem(null);
                  setItems(tmp);
                  setFilterItems(tmp);

                  setDeleting(false);
                  setConfirmDeleteVisible(false);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setDeleting(false);
              }
              showStudentList();
            })
            .catch(error => {
              setDeleting(false);
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
            });
    }

    const showStudentList = function(){
      if(schoolClass.id != null){
              setLoading(true);
      

      var params = {login:util.getTrustedUser(), lastIndex:0, pageSize:0, useParent:false, degree:-1, schoolClassId:schoolClass.id, fieldId:"", searchText:""};
      var url = config.Server+`/school/school-student/list`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  console.log("response is>", response);
                  
                  setItems(response);
                  setFilterItems(response);
                  
                  setLoading(false);
                  setStudentListVisible(true);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });

        
      }
    }

    const closeSelectStudentDialog = function(){
      setStudentSelectorOpen(false);
    }

    const onAcceptSelectedStudentDialog = function(students){
      console.log(students);
      var studentIds = [];
      for(var i = 0 ; i<students.length; i++){
        studentIds.push(students[i].user.id);
      }
      var params = {login:util.getTrustedUser(), schoolClassId:schoolClass.id, studentIds:studentIds};
      var url = config.Server+`/school/school-class/students/set`;
      console.log("student-->", studentIds);
      console.log("student-->", props.selectedItems);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  showStudentList();
                  closeSelectStudentDialog();
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
              
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });
      
    }

    const showStudentDialog = function(){
      if(schoolClass.id != null){
        console.log("school class is>", schoolClass);
        setStudentSelectorOpen(true);
      }
    }

    const onComboChange = function(name, value){
      if(name === "schoolClass"){
        setSchoolClass(value);
      }
      console.log("value-->",value);
      if((schoolClass != value && schoolClass.id != null) || value == {} || value == null){
        setStudentListVisible(false);
      }
      return
    }
    const showField = function (row){
      console.log("row is>", row);
      return(
        <span>
        {row.field.title}
        </span>
      )
    }
    return(      
      <>   
        <>
        <ShowVideo videoId="school_classing_students" top={65} md={6} /> 
          <div className="page-caption">کلاس بندی دانش آموزان</div>
          <Row>
            <Col md={3}>
              <SchoolClassCombo returnFullItem={true} value={schoolClass} onChange={(val) => onComboChange('schoolClass', val)} />
            </Col>
            <Col md={3}>
              <div style={{float:'right', paddingTop:'25px', paddingRight:'0px', margin:'5px', width:"300px", display:'block', height:"75px", direction:"ltr", textAlign:"right"}}>
                <Button label="مشاهده دانش آموزان کلاس" icon="pi pi-book" onClick={()=>showStudentList()} severity="info" iconPos="right" />
              </div>
            </Col>
          </Row>
          {
          studentSelectorOpen? <StudentSelector onlyFreeStudent={true} onlyParent={false} degree={schoolClass.itemValue.degree} fieldId={schoolClass.itemValue.field.id} onAccept={(students)=>onAcceptSelectedStudentDialog(students)} onClose={()=>{closeSelectStudentDialog()}}/>:<></>
          }

          {
            studentListVisible?

              <div className="card" style={{overflow:"scroll"}}>                
                <div style={{backgroundColor:'#e9edffff', marginTop:'0px', marginRight:"6px", padding:'5px', borderRadius:'5px', width:"100%", display:'flow-root'}}>
                  <Row>
                    <Col md={2}>
                      <div style={{paddingTop:'0px', paddingRight:'10px', margin:'5px', width:"300px", display:'block', direction:"ltr", textAlign:"right"}}>
                        <Button label="افزودن دانش آموز به کلاس" icon="pi pi-plus" onClick={()=>showStudentDialog()} severity="success" iconPos="right" />
                      </div>
                    </Col>
                    <Col md={2}>
                      <div style={{paddingTop:'0px', paddingRight:'10px', margin:'5px', width:"300px", display:'block', direction:"ltr", textAlign:"right"}}>
                        <Button label="حذف دانش آموز از کلاس" icon="pi pi-times" onClick={()=>deleteItems()} severity="danger" iconPos="right" />
                      </div>
                    </Col>
                  </Row>
                </div>

                <DataTable value={filterItems} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{ minWidth: '50rem' }} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" 
                currentPageReportTemplate="{first} تا {last} از {totalRecords}"
                dataKey="id"  selection={currentItem}  onSelectionChange={(e) => {setCurrentItem(e.value)}}>
                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                        <Column header="#" headerStyle={{ width: '3rem' }} body={(data, options) => options.rowIndex + 1}  className="list-cell-text-align"></Column>
                        {config.ShowListId? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column>: <></>} 
                        <Column field='nationalId' header={"کد ملی"} sortable className="list-cell-text-align"></Column>
                        <Column field='firstname' header={"نام"} sortable className="list-cell-text-align"></Column>
                        <Column field='lastname' header={"نام خانوادگی"} sortable className="list-cell-text-align"></Column>
                        <Column field='degree' header={"پایه"} sortable className="list-cell-text-align"></Column>
                        <Column body={(row) => showField(row)} header={"رشته"} sortable className="list-cell-text-align"></Column>
                </DataTable>
              </div>
            :<></>
          }

        </>   
      <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
      <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
      </>  
    );
}
